import { ConversationService } from '@forwardflow/services/ConversationService'
import useSWR from 'swr'

const fetcher = (leadId: number) =>
   ConversationService.getDemoInboxAppLead(leadId)

export function useDemoInboxAppLead(leadId: number) {
   const { data, error, isLoading, mutate } = useSWR(
      leadId ? ['demoInboxAppLead', leadId] : null,
      () => fetcher(leadId)
   )

   return {
      data,
      error,
      isLoading,
      mutate,
   }
}
